import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField/TextField";
import firebase from "../../../firebase/firebase";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  };
}

const styles = theme => ({
  paper: {
    position: "absolute",
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: "none",
    fontFamily: "Lato"
  }
});

const ContactButton = styled(Button)`
  &&& {
    text-transform: uppercase;
    color: #b3b3b3;
    font-weight: 600;
    font-size: 10pt;
    padding: 0;
    font-family: "Lato", sans-serif;

    @media (max-width: 600px) {
      font-size: 8pt;
      align-self: baseline;
      justify-items: center;
      margin-right: 0;
    }

    @media (max-width: 500px) {
      font-size: 7pt;
    }

    @media (max-width: 400px) {
      font-size: 6pt;
    }
  }
`;

const StyledTypo = styled(Typography)`
  &&& {
    font-size: 21px;
    text-align: center;
    margin-bottom: 2rem;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Text = styled(Typography)`
  &&& {
    text-align: center;
    margin-bottom: 2rem;
    font-size: 14px;
  }
`;

const StyledTextField = styled(TextField)`
  &&& {
    padding-bottom: 2rem;
  }
`;

class ContactUs extends Component {
  state = {
    open: false,
    email: "",
    name: "",
    message: ""
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  updateInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  addContactMessage = e => {
    e.preventDefault();
    const database = firebase.database();
    database.ref("ContactMessage").push({
      email: this.state.email,
      name: this.state.name,
      message: this.state.message
    });
    this.setState({
      email: "",
      name: "",
      message: ""
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <ContactButton onClick={this.handleOpen}>Contact Us</ContactButton>
        <Modal open={this.state.open} onClose={this.handleClose}>
          <Container style={getModalStyle()} className={classes.paper}>
            <StyledTypo id="modal-title">Contact Us</StyledTypo>
            <Text variant="subtitle1" id="description">
              Got a question ? We'd love to hear from you. Send us a message and
              we'll respond as soon as possible.
            </Text>
            <form onSubmit={this.addContactMessage}>
              <StyledTextField
                fullWidth
                type="name"
                name="name"
                value={this.state.name}
                onChange={this.updateInput}
                label="Name"
                variant="outlined"
              />
              <StyledTextField
                fullWidth
                type="email"
                name="email"
                value={this.state.email}
                onChange={this.updateInput}
                label="Email"
                variant="outlined"
              />
              <StyledTextField
                fullWidth
                multiline
                rows={4}
                type="text"
                name="message"
                value={this.state.message}
                onChange={this.updateInput}
                label="Message"
                variant="outlined"
              />
              <Button fullWidth variant="contained" type="submit">
                Submit
              </Button>
            </form>
          </Container>
        </Modal>
      </div>
    );
  }
}

ContactUs.propTypes = {
  classes: PropTypes.object.isRequired
};

// We need an intermediary variable for handling the recursive nesting.
const ContactUslWrapped = withStyles(styles)(ContactUs);

export default ContactUslWrapped;



// WEBPACK FOOTER //
// ./src/components/Pages/Contact/ContactUs.js